<template>
  <div class="big smartMedicalCare">
    <div class="page_title">名医工作室列表配置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container"
           style="padding: 10px 20px 20px 20px;">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息"
                       name="1"></el-tab-pane>
          <el-tab-pane label="列表维护"
                       :disabled="module_id_array[0] ? !module_id_array.includes('1577') : false"
                       name="2"></el-tab-pane>
        </el-tabs>
        <component :is="currentComponent" />
      </div>
    </div>

  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import BasicInfo from './BasicInfo.vue';
import ListMaintain from './ListMaintain.vue';
export default {
  components: {
    BasicInfo,
    ListMaintain
  },
  data() {
    return {
      activeName: '1'
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:ss');
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.activeName) {
        case '1':
          return BasicInfo;
        case '2':
          return ListMaintain;
      }
    }
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
</style>